import { render, staticRenderFns } from "./CategoryConfig.vue?vue&type=template&id=227638f5&scoped=true"
import script from "./CategoryConfig.vue?vue&type=script&lang=js"
export * from "./CategoryConfig.vue?vue&type=script&lang=js"
import style0 from "./CategoryConfig.vue?vue&type=style&index=0&id=227638f5&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227638f5",
  null
  
)

export default component.exports